import { helpers } from "./theme/helpers.js";
import { datePicker } from "./theme/components/datePicker.js";
import { repertoirFilter } from "./theme/components/repertoirFilter.js";
import MobileMenu from "./theme/components/menuToggler.js";
import { gallery } from "./theme/components/gallery.js";

window.theme = {
  globals: {
    isTouch: typeof window !== "undefined" && "ontouchstart" in window,
  },

  init: function () {
    var self = this;

    // inicializace mobile menu toggleru
    this.mobileMenu = new MobileMenu();
  },
};

jQuery(document).ready(function ($) {
  theme.init();
  datePicker.init();
  repertoirFilter.init();
  gallery.init();
});
